import { ThreadPrimitive, useAuiState } from '@assistant-ui/react';
import { AnimatePresence } from 'motion/react';

import { AssistantMessage } from './AssistantMessage.tsx';
import { Composer } from './Composer.tsx';
import { EditComposer } from './EditComposer.tsx';
import classes from './Thread.module.css';
import { ThreadScrollToBottom } from './ThreadScrollToBottom.tsx';
import { UserMessage } from './UserMessage.tsx';
import { AtlasAiHero } from '#plugin-chat/components/hero/AtlasAiHero.tsx';

/**
 * Main chat thread component orchestrating the conversation UI.
 * Uses assistant-ui primitives with custom message renderers and manual scroll control.
 */
export function Thread() {
  const isEmpty = useAuiState(({ thread }) => thread.messages.length === 0 && !thread.isLoading);
  const threadId = useAuiState(({ threadListItem }) => threadListItem.id);

  return (
    <ThreadPrimitive.Root className={classes.chatThread}>
      {/* turnAnchor="top": anchors viewport to top rather than bottom, preventing content jumps during streaming */}
      <ThreadPrimitive.Viewport autoScroll className={classes.viewport} turnAnchor="top">
        <AnimatePresence mode="popLayout">{isEmpty && <AtlasAiHero key="hero" />}</AnimatePresence>

        <div className={classes.viewportMessages}>
          <ThreadPrimitive.Messages
            components={{
              UserMessage,
              EditComposer,
              AssistantMessage,
            }}
            key={threadId}
          />
        </div>

        <ThreadPrimitive.ViewportFooter className={classes.viewportFooter} key="footer">
          <div className={classes.scrollToBottom}>
            <ThreadScrollToBottom />
          </div>
          <Composer />
        </ThreadPrimitive.ViewportFooter>
      </ThreadPrimitive.Viewport>
    </ThreadPrimitive.Root>
  );
}
